import { ref } from 'vue';

type Theme = 'dark' | 'light';

function initial(): Theme {
  const attr = document.documentElement.dataset.theme;
  if (attr === 'light' || attr === 'dark') return attr;
  return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
}

export const theme = ref<Theme>(initial());

export function toggleTheme() {
  theme.value = theme.value === 'dark' ? 'light' : 'dark';
  document.documentElement.dataset.theme = theme.value;
  try {
    localStorage.setItem('st-theme', theme.value);
  } catch {
    /* приватный режим */
  }
}
